<template>
  <div>

<b-container class="side-n" id=""  >
  <b-row class="custom-row" id="ROLE_COMPLAINT" >
    <b-col>
      <router-link to="/AdminComplaintStatus">
        <b-button block squared id="" class=" btn-color " >Complaint Status</b-button>
      </router-link>
    </b-col>
  </b-row>
  <b-row class="custom-row" id="ROLE_CONTACT">
    <b-col >
        <router-link to="/AdminUpdateContact">
          <b-button  block squared id="" class=" btn-color btn-color-active">Update Contact</b-button>
        </router-link>
   </b-col>
  </b-row>
  <b-row class="custom-row" id="ROLE_TENDER">
    <b-col >
      <b-button  block squared id="" class=" btn-color">
        Tender
      </b-button>
   </b-col>
  </b-row>
  <b-row class="custom-row" id="ROLE_DOCUMENT">
    <b-col >
      <b-button  block squared id="" class=" btn-color">
        Documents
     </b-button>
   </b-col>
  </b-row>
  <b-row class="custom-row" id="ROLE_CAREER">
    <b-col >
      <b-button  block squared id="" class=" btn-color">
        Career
     </b-button>
   </b-col>
  </b-row>
  <b-row class="custom-row" id="ROLE_NEWS">
    <b-col >
      <b-button  block squared id="" class=" btn-color">
        News and Media
     </b-button>
   </b-col>
  </b-row>




<!-- </b-collapse> -->
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {

  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;

  display:none;
}

.btn-block{
  height:50px;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;
 }
.btn-color:hover
{
  color: #ffff;
  background-color: #00838f ;
  border-color: #00838f;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0097a7;
  border-color: #0097a7;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
